var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5469 12.9015C76.7807 26.1353 83.8601 55.7602 70.6263 68.994C57.3925 82.2279 28.3119 78.9603 15.0781 65.7265C1.84422 52.4927 18.8978 31.7522 32.1316 18.5184C45.3655 5.28454 50.3131 -0.332331 63.5469 12.9015Z",
    fill: "#F7F8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 29.4999C48.5 29.4999 48.4446 30.3343 47.0336 31.2151C45.2699 32.3162 43.4508 31.0211 42.8872 30.0436C42.3235 29.0661 42.7278 26.6911 44.3301 26.1489C45.6118 25.7151 46.805 26.3279 47.2414 26.6885",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.114 60.6255C40.8216 58.9198 50.3447 56.0374 56.3071 54.1347M31 62.5C31 63.7921 36.2034 65.057 38.3974 63.9088C43 61.5 52.7252 58.2376 57.5011 56.1481C62.277 54.0586 62.277 51.6707 61.68 52.2677C61.5173 52.4303 59.3874 53.1518 56.3071 54.1347M37 33C37.796 34.194 38.5765 35.4921 40.4869 35.2533C42.8748 34.9548 48.5462 34.3578 50.3372 34.9548C52.1282 35.5518 58.9935 38.2382 58.9935 39.1337C58.9935 40.0292 58.6951 41.8202 55.4116 40.9247C52.1282 40.0292 52.1282 38.5367 51.2327 38.8352C50.3372 39.1337 49.7402 38.5367 50.0387 41.2232C50.3372 43.9096 53.9191 45.1036 55.1131 46.8946C56.0683 48.3274 56.3071 52.3184 56.3071 54.1347",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2684 59.4296C38.7709 56.9422 38.4569 49.5794 39.8897 48.3854C41.6806 46.8929 43.7702 44.5049 43.1732 41.8185C42.5762 39.132 41.0835 37.6396 39.5912 38.2366C38.0988 38.8335 33.0244 34.356 33.0244 33.4606C33.0244 32.5651 32.7259 31.3711 34.2183 31.3711M43.1488 57.9371C43.1488 57.0417 41.6803 50.7733 44.0682 48.9823C45.9786 47.5495 47.0532 46.5943 47.3517 46.2958C48.9436 47.0918 52.1873 48.9226 52.4261 49.8778C52.6649 50.833 52.9236 53.6587 53.0231 54.9522",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.f8dd7265a9547be0d5a6ec191c1fef9e.svg";
export { ForwardRef as ReactComponent };